export const tours = [
  {
    id: '7Mjp0',
    title: 'Completed Property Tour',
    url: 'https://kuula.co/share/collection/7Mjp0?logo=1&card=1&info=0&logosize=54&fs=1&vr=1&sd=1&initload=0&thumbs=1',
  },
  {
    id: '7dlzm',
    title: 'Virtual Staging',
    url: 'https://kuula.co/share/collection/7dlzm?logo=1&card=1&info=0&logosize=54&fs=1&vr=1&sd=1&initload=0&thumbs=1',
  },
  {
    id: '7d5qQ',
    title: 'Property Documentation',
    url: 'https://kuula.co/share/collection/7d5qQ?logo=1&card=1&info=0&logosize=54&fs=1&vr=1&sd=1&initload=0&thumbs=1',
  },
  {
    id: '7TmY3',
    title: 'Construction Update Phase 3/4',
    url: 'https://kuula.co/share/collection/7TmY3?logo=1&card=1&info=0&logosize=54&fs=1&vr=1&sd=1&initload=0&thumbs=1',
  },
  {
    id: '7TfTc',
    title: 'Exterior Demo',
    url: 'https://kuula.co/share/collection/7TfTc?logo=1&card=1&info=0&logosize=54&fs=1&vr=1&sd=1&initload=0&thumbs=1',
  },
]
